import QueryString from 'qs';
import { ProductType } from '../../interfaces/orders';
import { getDateTimeFromDate } from '../../libs/utils/helpers';
import { parseStatisticsDateFilter } from './dateFilterPresets';

type ParsedFilterOption = {
  value?: string;
  label?: string;
};

const statisticsPopulate = [
  '*',
  'partecipations.guests',
  'section',
  'balance.price',
  'balance.contributes',
  'balance.wines',
  'balance.food',
  'balance.rooms',
  'balance.sponsorship',
  'balance.contributes',
  'balance.extras',
  'balance.teacherPayments',
  'balance.couponsExpenses',
  'balance.couponsVirtuosity',
  'balance.discountExpenses',
  'balance.sectionVariousExpenses',
  'balance.teacherRefunds',
  'balance.direction',
  'balance.sectionDirectionIncome',
  'headquarterBalance.cards',
  'headquarterBalance.administrations',
  'headquarterBalance.teachingMaterial',
  'headquarterBalance.shipping',
  'headquarterBalance.safetyMargin',
  'headquarterBalance.reimbursement',
  'partecipations',
];

const parseFilterOptions = (
  searchParams: URLSearchParams,
  filterName: string
): ParsedFilterOption[] => {
  return Object.entries(QueryString.parse(searchParams.get(filterName) || ''))
    .map(([, value]) => value as ParsedFilterOption)
    .filter((value) => Boolean(value?.value));
};

const getSelectedOptionValues = (
  searchParams: URLSearchParams,
  filterName: string
) => {
  return parseFilterOptions(searchParams, filterName)
    .map((option) => option.value)
    .filter((value): value is string => Boolean(value));
};

export const getStatisticsSearchQuery = (
  searchParams: URLSearchParams,
  productType: ProductType
) => {
  const currentYear =
    Number(searchParams.get('year')) || new Date().getFullYear();
  const selectedSectionIds = getSelectedOptionValues(
    searchParams,
    `${productType}Sections`
  );
  const selectedStatuses = getSelectedOptionValues(
    searchParams,
    `${productType}status`
  );
  const selectedDateRange = parseStatisticsDateFilter(
    searchParams,
    `${productType}Date`
  );
  const search = searchParams.get(`${productType}search`);

  const filters: Record<string, any> = {
    startDate: selectedDateRange
      ? {
          ...(selectedDateRange.from
            ? { $gte: selectedDateRange.from }
            : {}),
          ...(selectedDateRange.to
            ? { $lte: getDateTimeFromDate(selectedDateRange.to) }
            : {}),
        }
      : { $contains: currentYear.toString() },
    ...(search !== null
      ? {
          title: {
            $contains: search,
          },
        }
      : {}),
    ...(selectedSectionIds.length > 0
      ? {
          section: {
            id: {
              $in: selectedSectionIds,
            },
          },
        }
      : {}),
    $and: [
      {
        status: {
          $notNull: true,
          ...(selectedStatuses.length > 0
            ? {
                $in: selectedStatuses,
              }
            : {}),
        },
      },
    ],
  };

  return {
    populate: statisticsPopulate,
    sort: 'startDate:desc',
    pagination: {
      page: searchParams.get(`${productType}Page`),
      pageSize: searchParams.get(`${productType}PageSize`),
    },
    filters,
  };
};
